<script>
import ErrorAlert from '~/javascripts/components/error_alert.vue';
import PurchaseSuccessModal from '~/javascripts/purchase/components/purchase_success_modal.vue';
import NewGitlabSubscriptionForm from '~/javascripts/subscription/components/new_gitlab_subscription_form.vue';
import ZuoraAvailabilityWrapper from '~/javascripts/components/zuora_availability_wrapper.vue';
import {
  ERROR_PROCESSING_PAYMENT_TYPE,
  PURCHASE_ERROR_DICTIONARY,
} from '~/javascripts/purchase/error_dictionary';
import { GITLAB_CREDITS_PLAN_TYPE } from '~/javascripts/subscription/constants';

export default {
  name: 'NewGitLabSubscription',
  components: {
    ErrorAlert,
    PurchaseSuccessModal,
    NewGitlabSubscriptionForm,
    ZuoraAvailabilityWrapper,
  },
  props: {
    successRedirectPath: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    namespaces: {
      type: Array,
      required: true,
    },
    planId: {
      type: String,
      required: true,
    },
    planName: {
      type: String,
      required: true,
    },
    currentNamespaceId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      error: null,
      showSuccessModal: false,
    };
  },
  computed: {
    currentNamespaceName() {
      return this.namespaces?.find((namespace) => namespace.id === this.currentNamespaceId)?.name;
    },
    successModalPrimaryAction() {
      const url = new URL(this.successRedirectPath, window.location.origin);
      const isGitlabCredits = url.searchParams.get('plan_type') === GITLAB_CREDITS_PLAN_TYPE;
      const text = isGitlabCredits ? 'Continue to add credits' : 'Manage purchases';
      return { text };
    },
  },
  methods: {
    showSuccess(payUrl) {
      if (payUrl) {
        window.location.href = payUrl;
      } else {
        // console.log('Not get pay url from response');
        // JH skip success modal for now
        // this.showSuccessModal = true;
      }
    },
    handleError(error) {
      this.error = error;
    },
  },
  PURCHASE_ERROR_DICTIONARY,
  defaultError: PURCHASE_ERROR_DICTIONARY[ERROR_PROCESSING_PAYMENT_TYPE],
};
</script>

<template>
  <div>
    <h1 class="font-weight-bold gl-my-7">{{ __('Buy subscription') }}</h1>

    <zuora-availability-wrapper>
      <h2 class="font-weight-bold gl-pb-2">{{ __(planName) }}</h2>
      <error-alert
        v-if="error"
        :dismissible="false"
        :error-dictionary="$options.PURCHASE_ERROR_DICTIONARY"
        :default-error="$options.defaultError"
        :error="error"
        :placeholders="{
          namespace: currentNamespaceName,
        }"
      />

      <new-gitlab-subscription-form
        :current-namespace-id="currentNamespaceId"
        :namespaces="namespaces"
        :plan-id="planId"
        :user="user"
        @error="handleError"
        @success="showSuccess"
      />

      <purchase-success-modal
        :visible="showSuccessModal"
        :success-redirect-path="successRedirectPath"
        title="Subscription purchased successfully!"
        :action-primary="successModalPrimaryAction"
      >
        <h3>{{ planName }}</h3>
      </purchase-success-modal>
    </zuora-availability-wrapper>
  </div>
</template>
